import { useGLTF } from "@react-three/drei";
import { GLTFDoorResult, GLTFMaterialResult } from "shared/utils/door";
import { useConfigurationOptionsContext } from "../../../../../../app/providers/DoorOptionsProvider";
import { getFullAssetPath } from "../../../../../../shared/utils/assets";
import Kozijn from "../../components/Kozijn";

import FramePassive from "../dubbel/components/FramePassive";
import GlassPassive from "../dubbel/components/GlassPassive";
import FrameActive from "../dubbel/components/FrameActive";
import GlassActive from "../dubbel/components/GlassActive";
import Handle from "../dubbel/components/Handle";

const KaderdeurDubbelV2 = () => {
  const { nodes } = useGLTF(
    getFullAssetPath("/objects-v3/kaderdeur-dubbel.glb"),
  ) as GLTFDoorResult;

  const { materials } = useGLTF(
    getFullAssetPath("/objects-v3/materialsCompressedv4.glb"),
  ) as GLTFMaterialResult;

  const { handle, getConfigurationWidth, selfAssembleDoorData } =
    useConfigurationOptionsContext();

  // Door rotation - draairichting
  const isRotationRight =
    selfAssembleDoorData.measurements.rotation === "right";

  const activeIndex = isRotationRight ? 1 : 0;
  const passiveIndex = isRotationRight ? 0 : 1;
  const widthActive = getConfigurationWidth(activeIndex);
  const widthPassive = getConfigurationWidth(passiveIndex);

  return (
    <group dispose={null}>
      <group>
        <Kozijn
          doorNodes={nodes}
          materials={materials}
          index={0}
          existingFrame={false}
          widths={[widthPassive, widthActive]}
          option={"double"}
        />
      </group>
      <group scale-y={1}>
        <FramePassive
          doorNodes={nodes}
          materials={materials}
          index={passiveIndex}
        />
        <GlassPassive
          doorNodes={nodes}
          materials={materials}
          index={passiveIndex}
        />
      </group>
      <group scale-y={1}>
        <FrameActive
          doorNodes={nodes}
          materials={materials}
          index={activeIndex}
        />
        <GlassActive
          doorNodes={nodes}
          materials={materials}
          index={activeIndex}
        />
        <group rotation-y={isRotationRight ? Math.PI : 0}>
          <Handle
            doorNodes={nodes}
            materials={materials}
            secondary={false}
            reverse={true}
            type={handle ? handle.code : ""}
            index={0}
          />
        </group>
      </group>
    </group>
  );
};

export default KaderdeurDubbelV2;
